.popover-container {
    padding: 16px;
    max-width: 250px;
}
